"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryCheckbox = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _reactHookForm = require("react-hook-form");
var _Localization = require("../../../Localization");
var _defaultTranslations = require("../../../constants/defaultTranslations");
var _TranslationKey = require("../../../models/TranslationKey");
var _jsxRuntime = require("react/jsx-runtime");
const PrimaryCheckbox = props => {
  const {
    initialValue,
    displayOrder,
    isDisabled,
    name,
    isAvailable,
    isEditable
  } = props;
  const {
    getTestId
  } = (0, _testidGenerator.default)();

  // eslint-disable-next-line  @typescript-eslint/prefer-nullish-coalescing -- we need logical operator
  const correctDisabled = isDisabled || !isEditable;
  if (!isAvailable) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
    size: {
      xs: 12,
      sm: 12
    },
    style: {
      order: displayOrder ?? 97
    },
    mb: 5,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.Controller, {
      name: name,
      defaultValue: initialValue,
      render: ({
        field
      }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormControlLabel, {
        control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Checkbox, {
          ...field,
          checked: field.value,
          disabled: correctDisabled,
          "data-testid": getTestId('is-primary')
        }),
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          defaultMessage: _defaultTranslations.defaultTranslations.isPrimary,
          id: _TranslationKey.TranslationKey.isPrimary
        })
      })
    })
  });
};
exports.PrimaryCheckbox = PrimaryCheckbox;
//# sourceMappingURL=PrimaryCheckbox.js.map